import { types } from "./types";

const initialState = {
  // mainObligations: {},
  // internalObligations: {},
  // laws: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_OBLIGATION_DOCUMENTS.SUCCESS:
      return {
        ...state,
        mainObligations: action.payload?.mainDocuments,
        internalObligations: action.payload?.internalDocuments
      }
    case types.SET_LAW_DOCUMENTS.SUCCESS:
      return {
        ...state,
        laws: action.payload?.lawDocuments,
      }
    case types.UPLOAD_FILE.SUCCESS:
      const obligationId = action.payload?.obligation_id      
      return {
        ...state,
        [action.group]: {
          ...state[action.group],
          [obligationId]: [...state[action.group][obligationId], action.payload]
        }
      };
    case 'SET_LOADING_PERMISSIONS':
      return {
        ...state,
        loading: action.payload,
      }
    case types.DOWNLOAD_FILE.SUCCESS: 
      return {
        ...state
      }
    case 'ADD_INTERNAL_DOCUMENT_KEY':
      return {
        ...state,
        internalObligations: {...state.internalObligations, [action.payload]: []},
      }
    default:
      return state;
  }
};

export default reducer;
